import { TypeResponse } from 'gtd-ng-widget';

export class HelloWidgetResponse extends TypeResponse {
  public clicks_count: number;
  public conversions_count: number;
  public payout_sum: number;
  public first_name: string;
  public last_name: string;
  public goalItemsFtd: number;
  public goalItemsLead: number;
  public user_logo: string;
}
